import { ArrowLeft } from 'lucide-react';
import type { Billet, Commande } from '../../api/types';
import EventCard from '../EventCard';
import { Button } from '../ui';
import ResumeCommande from './ResumeCommande';

/**
 * En-tête de la fiche commande : carte événement avec barre (retour, n° de commande),
 * événement et acheteur mis en avant. Les réglages sont dans l'onglet « Commande » (ReglagesCard).
 */
export default function CommandeHeader({
  commande,
  billets,
  now,
  onBack,
}: {
  commande: Commande;
  billets: Billet[];
  /** Heure serveur (en-tête `Date`) : c'est elle que l'app utilise pour le dévoilage. */
  now: Date;
  onBack: () => void;
}) {
  return (
  <EventCard
      gradientKey={commande.libelleManif}
      title={commande.libelleManif}
      dateSeance={commande.dateSeance}
      lieu={commande.libelleLieu}
      ville={commande.ville}
      statut={commande.statut}
      size="compact"
      topBar={
        <div>
          <Button size="sm" variant="ghost" className="-ml-2" onClick={onBack}>
            <ArrowLeft size={15} aria-hidden />
            Commandes
          </Button>
          <h1 className="mt-1 text-2xl/8 font-bold tracking-[0.48px] text-white">Commande {commande.idCommande}</h1>
        </div>
      }
    >
      <ResumeCommande
        commande={commande}
        qrDelivres={billets.some((billet) => Boolean(billet.numeroCodeBarre?.trim()))}
        now={now}
      />

      {commande.parentGuid ? (
        <p className="mt-1 text-xs text-outline-variant">
          Commande reçue par transfert de <span className="font-mono">{commande.parentGuid}</span>
        </p>
      ) : null}

      <p className="mt-2 text-xs/4 text-outline">
        séance #{commande.idSeance}
        <span className="ml-2 font-mono">{commande.guid}</span>
      </p>
    </EventCard>
  );
}
